<template>
  <span v-for="(text, index) in content.text" :key="index">
    <p v-if="isString(text)" v-reveal="reveal ? 0 : false">{{ text }}</p>

    <ul v-if="isList(text)" class="list-group">
      <li
        v-for="(value, index) in text"
        :key="index"
        class="list-group-item"
        v-reveal="reveal ? Math.min(index * 60, 300) : false"
      >
        {{ value }}
      </li>
    </ul>
  </span>
</template>

<script>
export default {
  props: {
    content: Object,
    reveal: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isString(value) {
      return typeof value === "string" || value instanceof String;
    },
    isList(value) {
      return Object.prototype.toString.call(value) === "[object Array]";
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin: 0 0 $space-4;
}

.list-group-item {
  position: relative;
  display: block;
  padding: $space-3 $space-4;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid $border;

  &:first-child {
    border-top-left-radius: $radius-sm;
    border-top-right-radius: $radius-sm;
  }

  &:last-child {
    margin-bottom: 0;
    border-bottom-left-radius: $radius-sm;
    border-bottom-right-radius: $radius-sm;
  }
}
</style>
